import type { CurrencyEnum } from '../generated/enums.ts';

export const DEFAULT_CURRENCY: CurrencyEnum = "EUR";
export const DEFAULT_LOCALE = "nl-NL";
export const CURRENCY_OPTIONS: Array<{ value: CurrencyEnum; symbol: string }> = [
    {value: 'EUR', symbol: '€'},
    {value: 'USD', symbol: '$'},
    {value: 'GBP', symbol: '£'},
    {value: 'CHF', symbol: 'CHF'},
    {value: 'PLN', symbol: 'zł'},
    {value: 'SEK', symbol: 'kr'},
    {value: 'DKK', symbol: 'kr'},
    {value: 'CZK', symbol: 'Kč'},
    {value: 'HUF', symbol: 'Ft'},
    {value: 'RON', symbol: 'lei'},
    {value: 'CNY', symbol: '¥'}
]

export const ALL_BUSINESSES_VALUE = "all";
export const ALL_BUSINESSES_LABEL = "All businesses";
